import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from './assets/Logo--Ubiant.png'


const _hoisted_1 = { class: "h-full" }
const _hoisted_2 = { class: "flex flex-column justify-content-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex align-items-center justify-content-center m-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ci-arrows-full-down rotate-90" })
], -1)
const _hoisted_4 = { class: "flex align-items-center justify-content-center m-2" }
const _hoisted_5 = { class: "app-label" }
const _hoisted_6 = { class: "flex align-items-center justify-content-center" }
const _hoisted_7 = { class: "-rotate-180 w-mode-v-lr app-label-micro uppercase" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-column justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex align-items-center justify-content-center m-2" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "ci-icon-account" })
  ])
], -1)
const _hoisted_9 = { class: "flex align-items-center justify-content-center" }
const _hoisted_10 = { class: "-rotate-180 w-mode-v-lr app-label-micro uppercase" }
const _hoisted_11 = {
  key: 2,
  class: "flex flex-column h-full"
}
const _hoisted_12 = { class: "app-label-micro text-gray-l1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "ci-arrows-full-down -rotate-90" }, null, -1)
const _hoisted_14 = { class: "flex align-items-center justify-content-between m-2" }
const _hoisted_15 = { class: "app-label" }
const _hoisted_16 = { class: "flex flex-column m-2" }
const _hoisted_17 = { class: "text-left app-label-micro role mb-2 uppercase" }
const _hoisted_18 = { class: "text-left app-label-micro text-gray-l1" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "line-section-white" }, null, -1)
const _hoisted_20 = { class: "flex flex-column mt-auto" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "line-section-white" }, null, -1)
const _hoisted_22 = { class: "flex justify-content-center" }
const _hoisted_23 = { class: "app-label-small text-gray-l1 font-bold" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "line-section-white" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mb-3",
    src: _imports_0,
    alt: "logo-entreprise"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppMenuLink = _resolveComponent("AppMenuLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.menuActive && _ctx.loggedIn)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "flex flex-column justify-content-between h-8rem cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onMenuButtonClick($event)))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.userInitials), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.user.user_brand), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.menuActive && !_ctx.loggedIn)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "flex flex-column justify-content-between h-5rem cursor-pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onMenuButtonClick($event)))
        }, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('menu-label.login')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.menuActive)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", {
            class: "flex align-items-center justify-content-end m-2 cursor-pointer",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onMenuButtonClick($event)))
          }, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('commons.hide')), 1),
            _hoisted_13
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.user.first_name) + " " + _toDisplayString(_ctx.user.last_name), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.user.user_brand), 1),
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.userLicense), 1)
          ]),
          _hoisted_19,
          _createVNode(_component_AppMenuLink, { menuItems: _ctx.menuItems }, null, 8, ["menuItems"]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", {
              class: "cursor-pointer",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.logOut && _ctx.logOut(...args)))
            }, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('homeview.profil-left-bar.logout')), 1)
              ])
            ]),
            _hoisted_24,
            _hoisted_25
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}